

// Function to encrypt sensitive data
function roundPrice(value) {
    return Math.round(value);
}


export default roundPrice    